import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import {
  DEFAULT_LOCALE,
  FALLBACK_LOCALE,
  NAMESPACES,
  SUPPORTED_LOCALES,
  type Locale,
  type Namespace,
} from '@boletra/i18n';
import { detectLocale } from '@boletra/i18n/detector';

// Vite glob: trae los JSON al bundle al build, sin fetch.
const localeModules = import.meta.glob('../../../../packages/i18n/locales/**/*.json', {
  eager: true,
  import: 'default',
}) as Record<string, Record<string, unknown>>;

function buildResources() {
  const resources: Record<string, Record<string, Record<string, unknown>>> = {};
  for (const [path, content] of Object.entries(localeModules)) {
    const match = path.match(/locales\/([a-z]{2})\/([a-z_-]+)\.json$/);
    if (!match || !match[1] || !match[2]) continue;
    const locale = match[1];
    const ns = match[2];
    if (!SUPPORTED_LOCALES.includes(locale as Locale)) continue;
    if (!NAMESPACES.includes(ns as Namespace)) continue;
    resources[locale] ??= {};
    resources[locale]![ns] = content;
  }
  return resources;
}

let initialized = false;

export function initI18n() {
  if (initialized) return i18next;
  const initialLocale = detectLocale({
    url: window.location.pathname,
    cookie: document.cookie,
    acceptLanguage: navigator.languages?.join(','),
  });

  i18next
    .use(ICU)
    .use(initReactI18next)
    .init({
      lng: initialLocale,
      fallbackLng: FALLBACK_LOCALE,
      supportedLngs: [...SUPPORTED_LOCALES],
      defaultNS: 'common',
      ns: [...NAMESPACES],
      resources: buildResources(),
      interpolation: { escapeValue: false },
      returnNull: false,
    });

  initialized = true;
  return i18next;
}

export function setLocale(locale: Locale) {
  i18next.changeLanguage(locale);
  document.cookie = `boletra_locale=${locale}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
}

export { DEFAULT_LOCALE, SUPPORTED_LOCALES };
export type { Locale };
